import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { Formater, TypeRecords } from "src/framework/commons/Formater";

export interface PaybackProps {
  ano: number;
  'Retorno do Investimento': number;
}

interface GraficoPaybackProps {
  data: PaybackProps[]
}

export function GraficoPayback({ data }: GraficoPaybackProps){
  return (
    <ResponsiveContainer>
      <BarChart data={data}>
        <XAxis dataKey="ano" />
        <YAxis width={120} tickFormatter={(value) => Formater.toString(value, TypeRecords.CURRENCY)} interval="preserveEnd" padding={{ top: 30 }} />
        <Tooltip formatter={(value) => Formater.toString(value, TypeRecords.CURRENCY)} />
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <Bar
          isAnimationActive={false}
          dataKey={'Retorno do Investimento'}
          fill="#ed7d31"
          stroke="#ed7d31"
        >
          {data &&
            data.map((entry) => {
              return (
                <Cell key={`cell-${entry.ano}`} />
              );
            })}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}